export const SET_ESSENTIAL_INFO = (T) => `SET_ESSENTIAL_INFO_${T.toUpperCase()}`;

export const ESSENTIAL_INFO_ACTION_NAMES = {};

(() => {
    [
        'guide',
    ].forEach((entityType) => {
        entityType = entityType.toUpperCase();
        ESSENTIAL_INFO_ACTION_NAMES[entityType] = {};
        ESSENTIAL_INFO_ACTION_NAMES[entityType]['SET_ESSENTIAL_INFO'] = SET_ESSENTIAL_INFO(entityType);
    });
})();
